import { createContext, createElement } from "react";
import { AuthApiClient, PortalApiClient } from "./api";
export const PassportContext = createContext(undefined);
export function PassportProvider({ environment, authApiUrl, portalApiUrl, children, }) {
    if (environment && !["mainnet", "testnet"].includes(environment)) {
        throw new Error("Wrong environment passed to PassportProvider.");
    }
    return createElement(PassportContext.Provider, {
        value: {
            authApiClient: new AuthApiClient(environment ?? "mainnet", authApiUrl),
            portalApiClient: new PortalApiClient(environment ?? "mainnet", portalApiUrl),
            environment,
        },
    }, children);
}
//# sourceMappingURL=provider.js.map